// removed by extract-text-webpack-plugin
module.exports = {"surveyLink":"_19Imv","root":"_2gBra","backgroundDark":"_3yJXB","surveyText":"rKdro","surveyDismissIcon":"_1l8HK","message":"_3UiSf","themeGreen":"_2yKK4","globeIcon":"_3VtPl"};